import { newFunction } from "../../../lib/utils/script/newFunction";
import { getCompiledCatchErrorLogger } from "../../../lib/utils/script/evalRuntime";
const paramsSchema = {
  type: 'object',
  fields: [{
    id: 'script',
    type: 'string',
    title: '代码',
    default: 'state.xxx = "hello world";',
    'uc:allowInterop': false,
    'uc:allowExpr': false,
    ui: {
      type: 'exprInput',
      props: {
        type: 'javascript',
        multipleLine: true,
        hideIcon: true
      }
    }
  }]
};
export const runScriptAtom = {
  id: 'uicore:runScript',
  name: '执行 JavaScript',
  category: '逻辑',
  desc: ['- 可直接读写 **数据源** 面板里的各个变量', '- 可调用 LessCode 的函数和变量, 例如 `w.renderer.param`, `w.renderer.myFun()`', '  - 当前行为的上下文与 `w.renderer` 一致, 也可以省略 `w.renderer` 直接调用', '- 若调用了 `flow.abort()`，则后续步骤将会全被跳过', '- 支持 await，支持 return'].join('\n'),
  returnValue: '脚本 return 的值',
  paramsSchema: paramsSchema,
  execute: async (ctx, params) => {
    const fnBody = ['const renderer = __flow__.renderer || {};', 'return (async function () {', '  with(renderer){', '    const flow = __flow__;', '    const flowState = flow.state;', '    const $event = flow.$event;\n\n', '    try {', params.script, '    } catch (_err) {', getCompiledCatchErrorLogger('_err', params.script, '流程JS步骤'), '      throw _err;', '    }', '  }', '}).call(renderer)'].join('\n');
    // eslint-disable-next-line no-new-func
    const fn = newFunction(['__flow__'], fnBody);
    const result = await fn(ctx);
    return result;
  },
  *handleCollectDeps(ctx, step) {
    var _step$value$params;
    if (step.type !== 'eventFlowStep') return; // 这行其实没啥用，只是让TypeScript安静而已
    const code = (_step$value$params = step.value.params) === null || _step$value$params === void 0 ? void 0 : _step$value$params.script;
    if (typeof code === 'string') {
      yield {
        type: 'javascript',
        place: ['params', 'script'],
        description: '执行的 JavaScript'
      };
    }
  }
};